export const languages = [
  { Label: 'English', value: 'English', code: 'en', index: 0 },
  { Label: 'Spanish', value: 'Spanish', code: 'es', index: 1 },
  { Label: 'French', value: 'French', code: 'fr', index: 2 },
  { Label: 'Dutch', value: 'Dutch', code: 'nl', index: 3 },
  { Label: 'Italian', value: 'Italian', code: 'it', index: 4 },
  { Label: 'Japanese', value: 'Japanese', code: 'ja', index: 5 },
  { Label: 'Portuguese', value: 'Portuguese', code: 'pt', index: 6 },
  { Label: 'German', value: 'German', code: 'de', index: 7 },
];

export const defaultLanguage = 'English';
export const defaultLanguageCode = 'en';
